function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * dd-droppable.ts 10.3.1
 * Copyright (c) 2021-2022 Alain Dumesny - see GridStack root license
 */
import { DDManager } from './dd-manager';
import { DDBaseImplement } from './dd-base-impl';
import { Utils } from './utils';
import { isTouch, pointerenter, pointerleave } from './dd-touch';
// let count = 0; // TEST
export var DDDroppable = /*#__PURE__*/function (_DDBaseImplement) {
  function DDDroppable(el) {
    var _this;
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, DDDroppable);
    _this = _callSuper(this, DDDroppable);
    _this.el = el;
    _this.option = option;
    // create var event binding so we can easily remove and still look like TS methods (unlike anonymous functions)
    _this._mouseEnter = _this._mouseEnter.bind(_this);
    _this._mouseLeave = _this._mouseLeave.bind(_this);
    _this.enable();
    _this._setupAccept();
    return _this;
  }
  _inherits(DDDroppable, _DDBaseImplement);
  return _createClass(DDDroppable, [{
    key: "on",
    value: function on(event, callback) {
      _superPropGet(DDDroppable, "on", this, 3)([event, callback]);
    }
  }, {
    key: "off",
    value: function off(event) {
      _superPropGet(DDDroppable, "off", this, 3)([event]);
    }
  }, {
    key: "enable",
    value: function enable() {
      if (this.disabled === false) return;
      _superPropGet(DDDroppable, "enable", this, 3)([]);
      this.el.classList.add('ui-droppable');
      this.el.classList.remove('ui-droppable-disabled');
      this.el.addEventListener('mouseenter', this._mouseEnter);
      this.el.addEventListener('mouseleave', this._mouseLeave);
      if (isTouch) {
        this.el.addEventListener('pointerenter', pointerenter);
        this.el.addEventListener('pointerleave', pointerleave);
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      var forDestroy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.disabled === true) return;
      _superPropGet(DDDroppable, "disable", this, 3)([]);
      this.el.classList.remove('ui-droppable');
      if (!forDestroy) this.el.classList.add('ui-droppable-disabled');
      this.el.removeEventListener('mouseenter', this._mouseEnter);
      this.el.removeEventListener('mouseleave', this._mouseLeave);
      if (isTouch) {
        this.el.removeEventListener('pointerenter', pointerenter);
        this.el.removeEventListener('pointerleave', pointerleave);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.disable(true);
      this.el.classList.remove('ui-droppable');
      this.el.classList.remove('ui-droppable-disabled');
      _superPropGet(DDDroppable, "destroy", this, 3)([]);
    }
  }, {
    key: "updateOption",
    value: function updateOption(opts) {
      var _this2 = this;
      Object.keys(opts).forEach(function (key) {
        return _this2.option[key] = opts[key];
      });
      this._setupAccept();
      return this;
    }
    /** @internal called when the cursor enters our area - prepare for a possible drop and track leaving */
  }, {
    key: "_mouseEnter",
    value: function _mouseEnter(e) {
      // console.log(`${count++} Enter ${this.el.id || (this.el as GridHTMLElement).gridstack.opts.id}`); // TEST
      if (!DDManager.dragElement) return;
      if (!this._canDrop(DDManager.dragElement.el)) return;
      e.preventDefault();
      e.stopPropagation();
      // make sure when we enter this, that the last one gets a leave FIRST to correctly cleanup as we don't always do
      if (DDManager.dropElement && DDManager.dropElement !== this) {
        DDManager.dropElement._mouseLeave(e, true); // calledByEnter = true
      }
      DDManager.dropElement = this;
      var ev = Utils.initEvent(e, {
        target: this.el,
        type: 'dropover'
      });
      if (this.option.over) {
        this.option.over(ev, this._ui(DDManager.dragElement));
      }
      this.triggerEvent('dropover', ev);
      this.el.classList.add('ui-droppable-over');
      // console.log('tracking'); // TEST
    }
    /** @internal called when the item is leaving our area, stop tracking if we had moving item */
  }, {
    key: "_mouseLeave",
    value: function _mouseLeave(e) {
      var calledByEnter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // console.log(`${count++} Leave ${this.el.id || (this.el as GridHTMLElement).gridstack.opts.id}`); // TEST
      if (!DDManager.dragElement || DDManager.dropElement !== this) return;
      e.preventDefault();
      e.stopPropagation();
      var ev = Utils.initEvent(e, {
        target: this.el,
        type: 'dropout'
      });
      if (this.option.out) {
        this.option.out(ev, this._ui(DDManager.dragElement));
      }
      this.triggerEvent('dropout', ev);
      if (DDManager.dropElement === this) {
        delete DDManager.dropElement;
        // console.log('not tracking'); // TEST
        // if we're still over a parent droppable, send it an enter as we don't get one from leaving nested children
        if (!calledByEnter) {
          var parentDrop;
          var parent = this.el.parentElement;
          while (!parentDrop && parent) {
            var _parent$ddElement;
            parentDrop = (_parent$ddElement = parent.ddElement) === null || _parent$ddElement === void 0 ? void 0 : _parent$ddElement.ddDroppable;
            parent = parent.parentElement;
          }
          if (parentDrop) {
            parentDrop._mouseEnter(e);
          }
        }
      }
    }
    /** item is being dropped on us - called by the drag mouseup handler - this calls the client drop event */
  }, {
    key: "drop",
    value: function drop(e) {
      e.preventDefault();
      var ev = Utils.initEvent(e, {
        target: this.el,
        type: 'drop'
      });
      if (this.option.drop) {
        this.option.drop(ev, this._ui(DDManager.dragElement));
      }
      this.triggerEvent('drop', ev);
    }
    /** @internal true if element matches the string/method accept option */
  }, {
    key: "_canDrop",
    value: function _canDrop(el) {
      return el && (!this.accept || this.accept(el));
    }
    /** @internal */
  }, {
    key: "_setupAccept",
    value: function _setupAccept() {
      var _this3 = this;
      if (!this.option.accept) return this;
      if (typeof this.option.accept === 'string') {
        this.accept = function (el) {
          return el.classList.contains(_this3.option.accept) || el.matches(_this3.option.accept);
        };
      } else {
        this.accept = this.option.accept;
      }
      return this;
    }
    /** @internal */
  }, {
    key: "_ui",
    value: function _ui(drag) {
      return _objectSpread({
        draggable: drag.el
      }, drag.ui());
    }
  }]);
}(DDBaseImplement);